import styled from 'styled-components'

export const RecentSearches = styled.div`
    margin-bottom: 16px;

    &.small {
        margin-bottom: 8px;
    }
`